import { render, staticRenderFns } from "./UserSettingWizard.vue?vue&type=template&id=7ade1c6a&"
import script from "./UserSettingWizard.vue?vue&type=script&lang=js&"
export * from "./UserSettingWizard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports